module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-checklist"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Checklist")]), _vm._v(" "), _c('mt-checklist', {
    staticClass: "page-part",
    attrs: {
      "title": "复选框列表",
      "options": _vm.options1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }), _vm._v(" "), _c('div', [_c('mt-cell', {
    attrs: {
      "title": "选中的项"
    }
  }, [_vm._v(_vm._s(_vm.value1))])], 1), _vm._v(" "), _c('mt-checklist', {
    staticClass: "page-part",
    attrs: {
      "title": "第二个复选框列表",
      "options": _vm.options2
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }), _vm._v(" "), _c('div', [_c('mt-cell', {
    attrs: {
      "title": "选中的项"
    }
  }, [_vm._v(_vm._s(_vm.value2))])], 1), _vm._v(" "), _c('mt-checklist', {
    staticClass: "page-part",
    attrs: {
      "title": "最多选两个",
      "max": 2,
      "options": _vm.options3
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  }), _vm._v(" "), _c('div', [_c('mt-cell', {
    attrs: {
      "title": "选中的项"
    }
  }, [_vm._v(_vm._s(_vm.value3))])], 1), _vm._v(" "), _c('mt-checklist', {
    staticClass: "page-part",
    attrs: {
      "align": "right",
      "title": "右对齐",
      "options": _vm.options4
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1df5afb0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/checklist.vue
// module id = 270
// module chunks = 0